/* eslint-disable graphql/template-strings */
import { gql } from '@apollo/client';

export type OnNotificationCreatedResponse = {
  onNotificationCreated: Notification;
};

export const ON_NOTIFICATION_CREATED = gql`
  subscription OnNotificationCreated($userId: ID!) {
    onNotificationCreated(userId: $userId) {
      id
      title
      body
      imageUrl
      category
      createdAt
      isRead
    }
  }
`;
